import SessionTab from './SessionTab';

export default SessionTab;
